import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { Order, OrderStatus } from '@reims-local/types';
import { orderApi } from '../lib/api';

export function MyOrders() {
  const [rows, setRows] = useState<Array<{ order: Order; shop: { id: string; name: string; slug: string } }>>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    orderApi
      .listMine()
      .then((res) => setRows(res.data))
      .catch((err) => setError((err as Error).message === 'not_authenticated' ? 'Connectez-vous pour voir vos commandes.' : (err as Error).message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="container">
      <h2>Mes commandes</h2>
      {error && <div className="alert alert-error">{error}</div>}
      {loading ? (
        <p>Chargement…</p>
      ) : rows.length === 0 ? (
        <p className="muted">Vous n’avez pas encore passé de commande.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {rows.map(({ order, shop }) => (
            <Link to={`/mes-commandes/${order.id}`} key={order.id} style={{ color: 'inherit' }}>
              <div className="card">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                  <div>
                    <div><strong>{order.order_number}</strong> — {shop.name}</div>
                    <div className="muted" style={{ fontSize: 13 }}>
                      Retrait {formatPickup(order.pickup_slot)} · {(order.total_cents / 100).toFixed(2)} €
                    </div>
                  </div>
                  <span className={`badge ${statusClass(order.status as OrderStatus)}`}>{statusLabel(order.status as OrderStatus)}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </main>
  );
}

function statusClass(s: OrderStatus): string {
  if (s === 'picked_up') return 'green';
  if (s === 'cancelled') return 'red';
  if (s === 'ready') return 'blue';
  return 'orange';
}
function statusLabel(s: OrderStatus): string {
  const m: Record<OrderStatus, string> = {
    pending: 'En attente', confirmed: 'Confirmée', preparing: 'En préparation',
    ready: 'Prête à retirer', picked_up: 'Récupérée', cancelled: 'Annulée',
  };
  return m[s];
}
function formatPickup(iso: string): string {
  try {
    return new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'Europe/Paris', weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
    }).format(new Date(iso));
  } catch { return iso; }
}
